import(/* webpackMode: "eager" */ "/app/src/app/(apollo)/error.tsx");
